import * as yup from 'yup';
import useFetchMataData from '../../../../../../Components/Hooks/useFetchMataData';
import { Modal, notification } from 'antd';
import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import axiosInstance from '../../../../../../Services/axiosCommon';
import { CancelButton, SubmitButton } from '../../../../../../Components/Utils/Buttons';
import { NuInput, NuSelect, NuTextArea } from '../../../../../../Components/Utils/Input';
import FormikSelectTwo from '../../../../../../Components/Utils/Select';

function MultiEditEquipments({open,onCancel,getData,seletedIds,projectId,Activity}) {
  //   const {value:Category ,getData:refOthersCategory} = useFetchMataData(`/dropdown/dropdown-details/`,'OthersCategory')
  // const {value:Division ,getData:refOtherDivision} = useFetchMataData(`/dropdown/dropdown-details/`,'OtherDivision')
  // const {value:Unit ,getData:refOtherUnit} = useFetchMataData(`/dropdown/dropdown-details/`,'OtherUnit')
    //   console.log("finding",estiId);
    // const {value:Unit} = useFetchMataData(`/Metadata/unit`)
    const [api, contextHolder] = notification.useNotification();
    const [isLoading,setIsLoading] = useState(false);
   const [createNew, setCreateNew] = useState({
      
    item: "",
    unit: "",
    quantity: "",
    unitPrice: "",
    totalPrice: "",
     
    });
    const {value:Unit ,getData:  UnitEquipment} = useFetchMataData(`/dropdown/dropdown-details/`,'Unit_item')
  const {value:Type ,getData:  TypeEquipment} = useFetchMataData(`/dropdown/dropdown-details/`,'TypeEquipment')
  // const {value:Activity } = useFetchMataData(`/Activity/1/drop-down`,'Unit_item')

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: createNew,
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema:yup.object({
      //   name:yup.string().required("Tittle is Requried")
      }),
      onSubmit: (value,{resetForm}) => {    
        setIsLoading(true);
        const values = {
          ...value,
          ids: seletedIds
        }
        axiosInstance
        .put(`budget-equipment/multi-update/${projectId}/2`, values)
          .then((res) => {
            console.log(res);
            if (res.status === 201 || res.data.status == true) {
              setIsLoading(false);
              getData();
              resetForm();
              api.success({
                message: `Material Multi Item Edit successfully`,
                description: res?.data?.msg || "Added In Tittle",
                placement: "bottomRight",
              });
              onCancel();
            } else {
              api.error({
                message: `Material Multi Item Edit failed`,
                description: res?.data?.msg || "Network error",
                placement: "bottomRight",
              });
              setIsLoading(false);
            }
          })
          .catch((err) => {
            api.error({
              message: `Material Multi Item Edit failed`,
              description: err?.data?.msg || "Sever error (or) Network error",
              placement: "bottomRight",
            });
            setIsLoading(false);
          });
      },
    });
  
    useEffect(() => {
      const totalPrice = formik?.values?.actual_quantity * formik?.values?.actual_Price
      formik.setFieldValue("totalPrice", totalPrice);
    }, [formik?.values?.actual_quantity,formik?.values?.actual_Price]);
  
    return (
      <>
      {contextHolder}
      <Modal
        open={open}
        title={"Multi Edit Equipments"}
        width={"50%"}
        className="my-modal"
        centered
        footer={[]}
        onCancel={onCancel}
      >
      <form onSubmit={formik.handleSubmit} >
        <div className=" w-full flex flex-wrap">
        <FormikSelectTwo
           
           label="Item"
           placeholder="Item"
           formik={formik}
           name="item"
           
           isRequired={true}
           Options={Activity}
           width="w-full md:w-1/2"               
            
       />
             <FormikSelectTwo
          label="Type"
          width="w-full md:w-1/2"    
          formik={formik}
          placeholder="Choose"
          name="type"
          Options={Type}
          />
      
           <FormikSelectTwo
          label="Unit"
          width="w-full md:w-1/2"    
          formik={formik}
          placeholder="Choose"
          name="unit"
          Options={Unit}
          />
            
           <NuInput
              type="number"
              label=" Quantity"
              placeholder=" Quantity"
              formik={formik}
              name="quantity"
              width="w-full md:w-1/2"
            />
            <NuInput
                         type="number"

              label="UnitPrice"
              placeholder="unitPrice"
              formik={formik}
              name="unitPrice"
              width="w-full md:w-1/2"
            />
            <NuInput
                         type="number"

              label="TotalPrice"
              placeholder="totalPrice"
              formik={formik}
              name="totalPrice"
              width="w-full md:w-1/2"
              disabled={true}
            />
              <div className="w-full flex justify-end item-end float-right mx-auto md:mx-0 gap-2 mt-2 md:mr-4">
                <CancelButton handleClick={onCancel} />
                <SubmitButton isLoading={isLoading} />
              </div>
        </div>
        </form>
      </Modal>
      </>
    )
    }
    
    export default MultiEditEquipments;